import axios from 'axios';
import {
  LOGIN_URL,
  GOOGLE_LOGIN_URL,
  PERMISSIONS_URL,
} from 'api/session/constant';

export function performLogin(credentials) {
  return axios
    .post(`${LOGIN_URL}`, credentials)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGoogleLogin(idToken) {
  return axios
    .post(`${GOOGLE_LOGIN_URL}`, { id_token: idToken })
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function getPermissions() {
  return axios.get(PERMISSIONS_URL);
}
